import React from 'react'
import './SongStyles.css'

import Dance from '../assets/Dancewithme.png'
import Fool from '../assets/Onlyafool.png'
import Silent from '../assets/Silent.png'
import Stim from '../assets/Stimulate.png'
import Sign from '../assets/showmeasign.png'
import Blood from '../assets/bloodstream.png'
import Tonight from '../assets/tonight.png'
import Wait from '../assets/waitforyou.png'
import Fall from '../assets/fall.jpg'

function Song() {
  return (
    <div>
      <section id='song-list'>
        <h1>Latest Song</h1>
        <div className='newest'>
          <article className='song-item'>
            <div className='item-image'>
              <img src={Fall} alt=''>
              </img>
            </div>
            <h3>The Fall</h3>
            <a href='https://open.spotify.com/track/7hWt5I5sEA54Za6KKzislx?si=YcKwcuySQtWhAoGAoOUp5Q' className='btn' target=''>Listen</a>
          </article>
        </div>
        <h1>More Songs</h1>
        <div className='contain container'>

            <article className='song-item'>
            <div className='item-image'>
              <img src={Silent} alt=''>
              </img>
            </div>
            <h3>Silent</h3>
            <a href='https://soundcloud.com/theshipwrek/sets/silent' className='btn' target=''>Listen</a>
          </article>

          <article className='song-item'>
            <div className='item-image'>
              <img src={Dance} alt=''>
              </img>
            </div>
            <h3>Dance With Me</h3>
            <a href='https://soundcloud.com/theshipwrek/sets/dance-with-me' className='btn' target=''>Listen</a>
          </article>
          <article className='song-item'>
            <div className='item-image'>
              <img src={Fool} alt=''>
              </img>
            </div>
            <h3>Only A Fool</h3>
            <a href='https://soundcloud.com/wearegalantis/galantis-x-ship-wrek-x-pink-sweat-only-a-fool-d-sol-remix' className='btn' target=''>Listen</a>
          </article>
      
          <article className='song-item'>
            <div className='item-image'>
              <img src={Sign} alt=''>
              </img>
            </div>
            <h3>Show Me A Sign</h3>
            <a href=' https://soundcloud.com/theshipwrek/show-me-a-sign' className='btn' target=''>Listen</a>
          </article>

          <article className='song-item'>
            <div className='item-image'>
              <img src={Blood} alt=''>
              </img>
            </div>
            <h3>Bloodstream</h3>
            <a href=' https://soundcloud.com/theshipwrek/bloodstream?in=theshipwrek/sets/mirror-mirror-97515859' className='btn' target=''>Listen</a>
          </article>

          <article className='song-item'>
            <div className='item-image'>
              <img src={Tonight} alt=''>
              </img>
            </div>
            <h3>Tonight</h3>
            <a href='https://soundcloud.com/theshipwrek/tonights' className='btn' target=''>Listen</a>
          </article>

          <article className='song-item'>
            <div className='item-image'>
              <img src={Wait} alt=''>
              </img>
            </div>
            <h3>Wait for You</h3>
            <a href='https://soundcloud.com/theshipwrek/wait-for-you-ship-wrek' className='btn' target=''>Listen</a>
          </article>

          <article className='song-item'>
            <div className='item-image'>
              <img src={Stim} alt=''>
              </img>
            </div>
            <h3>Stimulate</h3>
            <a href=' https://soundcloud.com/theshipwrek/stimulate-1' className='btn' target=''>Listen</a>
          </article>

        </div>
      </section>
      
    </div>
  )
}

export default Song